import DragHandleDots from "./SVG/dragHandleDots.svg?react";

const DragHandleDotsIcon = () => {
  return <DragHandleDots />;
};

export default DragHandleDotsIcon;
